import { setCookie, getCookie } from '../../../core/static/js/helpers/utils.js'
import BackendAPI from '../../../core/static/js/helpers/API.js'

class SizePicker extends HTMLElement {
  constructor() {
    super();
    
     // binding methods
     this.productType = this.getAttribute('producttype');
     this.currentStyle = this.getAttribute('style');
     this.sizes = JSON.parse(this.getAttribute('sizes'));
     this.sizeGuideUrl = this.getAttribute('sizeguideurl');
     this.seller = this.getAttribute('seller');
     this.sku = ''
     this.preview = this.getAttribute('preview');
     this._currentSize = null;
     this.sizeLabels = {
      "IN": {
        'men':{
          'XXS': 'Size XXS · 32 - 34',
          'XS': 'Size XS · 34 - 36',
          'S': 'Size S · 36 - 38',
          'M': 'Size M · 38 - 40',
          'L': 'Size L · 40 - 42',
          'XL': 'Size XL · 42 - 44',
          '2XL': 'Size 2XL · 44 - 46',
          '3XL': 'Size 3XL · 46 - 48',
          '4XL': 'Size 4XL · 48 - 50',
          '5XL': 'Size 5XL · 50 - 52',
          'Small': 'Size Small',
          'Petite': 'Size Petite',
          'Petite Tall': 'Size Petite Tall',
          'Regular': 'Size Regular',
          'Regular Tall': 'Size Regular Tall',
          'Large': 'Size Large',
          'Large Tall': 'Size Large Tall',
          'Large+': 'Size Large+',
          'Large+ Tall':'Size Large+ Tall',
          'Plus': 'Size Plus'
        },
        'women':{
            'XS': 'Size XS · 30 - 32',
            'S': 'Size S · 32 - 34',
            'M': 'Size M · 34 - 36',
            'L': 'Size L · 36 - 38',
            'XL': 'Size XL · 38 - 40',
            '2XL': 'Size 2XL · 40 - 42',
            '3XL': 'Size 3XL · 42 - 44',
            '4XL': 'Size 4XL · 48 - 50',
            '5XL': 'Size 5XL · 50 - 52',
            'Small': 'Size Small',
            'Petite': 'Size Petite',
            'Petite Tall': 'Size Petite Tall',
            'Regular': 'Size Regular',
            'Regular Tall': 'Size Regular Tall',
            'Large': 'Size Large',
            'Large Tall': 'Size Large Tall',
            'Large+': 'Size Large+',
            'Large+ Tall':'Size Large+ Tall',
            'Plus': 'Size Plus',
            'One Size': 'One Size',
            'old':{
              'XS': 'Size XS · 28 - 30',
              'S': 'Size S · 30 - 32',
              'M': 'Size M · 32 - 34',
              'L': 'Size L · 34 - 36',
              'XL': 'Size XL · 36 - 38',
              '2XL': 'Size 2XL · 38 - 40',
              '3XL': 'Size 3XL · 40 - 42',
            }
        },
        'unisex':{
          'Small': 'Size Small',
          'Petite': 'Size Petite',
          'Petite Tall': 'Size Petite Tall',
          'Regular': 'Size Regular',
          'Regular Tall': 'Size Regular Tall',
          'Large': 'Size Large',
          'Large Tall': 'Size Large Tall',
          'Large+': 'Size Large+',
          'Large+ Tall':'Size Large+ Tall',
          'Plus': 'Size Plus',
          'One Size': 'One Size',
          'Apron': 'One Size',
          'Apron + Peg': 'Walnut Wood Wall Peg',
          'Hand Towel': '16 x 30"',
          'Bath Towel': '30 x 57"',
          'Hand': '16 x 30"',
          'Bath': '30 x 57"',
          '2 Hand + 1 Bath': 'Combo Pack',
          '300ml': '300ml',
          '420ml': '420ml'
        },
        'refill':{
          '120 Sheets': 'Handle + 120 Sheets',
          '360 Sheets': '3-Pack Refill 120 Sheets',
        },
        'handle':{
          '120 Sheets': 'Handle + 120 Sheets',
          '360 Sheets': '3-Pack Refill 120 Sheets',
        }
      },
      "GB": {
        'men':{
            'XS': 'Size XS · 36 - 38',
            'S': 'Size S · 38 - 40',
            'M': 'Size M · 40 - 42',
            'L': 'Size L · 42 - 44',
            'XL': 'Size XL · 44 - 46',
            '2XL': 'Size 2XL · 46 - 48',
            '3XL': 'Size 3XL',
            'Small': 'Size Small',
            'Small Tall': 'Size Small Tall',
            'Petite': 'Size Petite',
            'Petite Tall': 'Size Petite Tall',
            'Regular': 'Size Regular',
            'Regular Tall': 'Size Regular Tall',
            'Large': 'Size Large',
            'Large Tall': 'Size Large Tall',
            'Large+': 'Size Large+',
            'Large+ Tall':'Size Large+ Tall',
            'Plus': 'Size Plus',
        },
        'women':{
            'XS': 'Size XS · 36 - 38',
            'S': 'Size S · 38 - 40',
            'M': 'Size M · 40 - 42',
            'L': 'Size L · 42 - 44',
            'XL': 'Size XL · 44 - 46',
            '2XL': 'Size 2XL · 46 - 48',
            '3XL': 'Size 3XL',
            'Small': 'Size Small',
            'Small Tall': 'Size Small Tall',
            'Petite': 'Size Petite',
            'Petite Tall': 'Size Petite Tall',
            'Regular': 'Size Regular',
            'Regular Tall': 'Size Regular Tall',
            'Large': 'Size Large',
            'Large Tall': 'Size Large Tall',
            'Large+': 'Size Large+',
            'Large+ Tall':'Size Large+ Tall',
            'Plus': 'Size Plus',
            "old": {
              'S': 'Size S · 37 - 39',
              'M': 'Size M · 39 - 41',
              'L': 'Size L · 41 - 43',
              'XL': 'Size XL · 43 - 45',
              '2XL': 'Size 2XL · 45 - 48',
              '3XL': 'Size 3XL',
          }
        },
        'unisex':{
          'Small': 'Size Small',
          'Small Tall': 'Size Small Tall',
          'Petite': 'Size Petite',
          'Petite Tall': 'Size Petite Tall',
          'Regular': 'Size Regular',
          'Regular Tall': 'Size Regular Tall',
          'Large': 'Size Large',
          'Large Tall': 'Size Large Tall',
          'Large+': 'Size Large+',
          'Large+ Tall':'Size Large+ Tall',
          'Plus': 'Size Plus',
          'One Size': 'One Size',
          'One Size + Peg': 'One Size + Peg'
        },
        'refill':{
          '120 Sheets': 'Handle + 120 Sheets',
          '360 Sheets': '3-Pack Refill 120 Sheets',
        },
        'handle':{
          '120 Sheets': 'Handle + 120 Sheets',
          '360 Sheets': '3-Pack Refill 120 Sheets',
        }
      }
    }
    this.maskSizeLabels = {
      "IN":{
      'unisex':{
          'Regular': 'Regular',
          'Plus': 'Plus',
        }
      }
    }
    this.hammoTrackSizeLabels = {
      "IN":{
      'men':{
          'S': 'Size S · W29 - 31',
          'S Tall': 'Size S Tall · W29 - 31',
          'M': 'Size M · W31 - 33',
          'M Tall': 'Size M Tall · W31 - 33',
          'L': 'Size L · W33 - 35',
          'L Tall': 'Size L Tall · W33 - 35',
          'XL': 'Size XL · W35 - 37',
          'XL Tall': 'Size XL Tall· W35 - 37',
          '2XL': 'Size 2XL · W37 - 39',
          '2XL Tall': 'Size 2XL Tall · W37 - 39',
        }
      }
    }
    this.hammoShortsSizeLabels = {
      "IN":{
      'men':{
          'S': 'Size S · W29 - 31',
          'M': 'Size M · W31 - 33',
          'L': 'Size L · W33 - 35',
          'XL': 'Size XL · W35 - 37',
          '2XL': 'Size 2XL · W37 - 39',
          '3XL': 'Size 3XL',
        },
        'women':{
          'S': 'Size S · W29 - 31',
          'M': 'Size M · W31 - 33',
          'L': 'Size L · W33 - 35',
          'XL': 'Size XL · W35 - 37',
          '2XL': 'Size 2XL · W37 - 39',
          '3XL': 'Size 3XL',
        },
      }
    }
    this.shortsSizeLabels = {
      "IN":{
      'men':{
          'Petite': 'Size Petite · 28 - 30',
          'Regular': 'Size Regular · 30 - 33',
          'Large': 'Size Large · 33 - 36',
          'XL': 'Size XL · 36 - 40',
          '2XL': 'Size 2XL · 40 - 43',
          '3XL': 'Size 3XL · 43 - 46',
        },
         'women':{
          'Petite': 'Size Petite · 26 - 28',
          'Regular': 'Size Regular · 28 - 30',
          'Large': 'Size Large · 30 - 32',
          'XL': 'Size XL · 32 - 34',
          '2XL': 'Size 2XL · 34 - 36',
          '3XL': 'Size 3XL · 36 - 38',
        }
      }
    }
    this.pyjamasSizeLabels = {
        "IN":{
        'men':{
            'Petite': 'Size Petite',
            'Petite Tall': 'Size Petite Tall',
            'Regular': 'Size Regular',
            'Regular Tall': 'Size Regular Tall',
            'Large': 'Size Large',
            'XL': 'Size XL · 35 - 37',
            '2XL': 'Size 2XL · 37 - 39',
            'Large Tall': 'Size Large Tall',
            'Large+': 'Size Large+',
            'Large+ Tall':'Size Large+ Tall',
          },
           'women':{
            'Petite': 'Size Petite',
            'Petite Tall': 'Size Petite Tall',
            'Regular': 'Size Regular',
            'Regular Tall': 'Size Regular Tall',
            'Large': 'Size Large',
            'XL': 'Size XL · 35 - 37',
            '2XL': 'Size 2XL · 37 - 39',
            'Large Tall': 'Size Large Tall',
            'Large+': 'Size Large+',
            'Large+ Tall':'Size Large+ Tall',
          }
        }
    }
    this.flatPantsSizeLabels = {
      "IN":{
      'women':{
          'XS': 'Size XS · W26 - 28',
          'S': 'Size S · W28 - 30',
          'M': 'Size M · W30 - 32',
          'L': 'Size L· W32 - 34',
          'XL': 'Size XL · W34 - 36',
          '2XL': 'Size 2XL· W36- 38',
          '3XL': 'Size 3XL · W38 - 40'
        }
      }
    }
    this.hairWrapLabels = {
      "IN":{
      'women':{
          'One Size': 'Fits All',
        }
      }
    }
    this.API = new BackendAPI();
    this.API.setBaseUrl(host + '/shop');
    this.renderTemplate();
  }
  get currentSize() {
    return this._currentSize;
  }
  set currentSize(val) {
    this._currentSize = val;
    this.saveSizeData(this.currentSize);
  }
  connectedCallback() {
      // Invoked each time the custom element is appended into DOM.
      this.saveProductData(this.getAttribute('type'), this.getAttribute('style'))
      this.renderSizes();
  }

  disconnectedCallback() {
    // Invoked each time the custom element is disconnected from the document's DOM.
  }

  renderTemplate(){
    // This is not Shadow DOM - can apply global css here.
    //  this.appendChild(cartTemplate.content.cloneNode(true));

    // const shadow = this.attachShadow({ mode: 'open' });
    // appending the container to the shadow DOM
    const sizePickerTemplate = document.createElement('template');
    sizePickerTemplate.innerHTML = `
        <select>
          <option selected value=''>Pick a Size</option>
        </select>
        <a href="${this.sizeGuideUrl}" target=”_blank” class="block-icon size-guide absolute-block"></a>
    `;
    this.appendChild(sizePickerTemplate.content.cloneNode(true));
  }

  async renderSizes(){
    let select = this.querySelector('select');
    var size  = this.getSizeFromCookies();
    if(!this.sizes || this.sizes.length <=0){
      return;
    }
    if (!size || size.length === 0){
        size = (this.sizes) ? this.sizes[0].value : select.selectedOptions[0].value;
    }
    this.currentSize = size;
    for(const size of this.sizes){
      var option = document.createElement("option");
      option.value = size.value;
      if (size.out_of_stock) {
        option.text = size.value + ' · Sold Out';
        option.disabled = size.out_of_stock;
      }
      else {
        if(this.seller == "IN"){
          if(this.productType == 'hammo-tracks'){
            option.text = this.hammoTrackSizeLabels[this.seller][this.currentStyle][size.value];
          }
          else if (this.productType == 'mask'){
            option.text = this.maskSizeLabels[this.seller][this.currentStyle][size.value];
          }
          else if (this.productType == 'shorts'){
            option.text = this.shortsSizeLabels[this.seller][this.currentStyle][size.value];
          }
          else if (this.productType == 'hammo-shorts'){
            option.text = this.hammoShortsSizeLabels[this.seller][this.currentStyle][size.value];
          }
          else if (this.productType == 'pyjamas'){
            option.text = this.pyjamasSizeLabels[this.seller][this.currentStyle][size.value];
          }
          else if (this.productType == 'flat-pants'){
            option.text = this.flatPantsSizeLabels[this.seller][this.currentStyle][size.value];
          }
          else if (this.productType == 'hair-wrap'){
            option.text = this.hairWrapLabels[this.seller][this.currentStyle][size.value];
          }
          else{
            option.text = this.sizeLabels[this.seller][this.currentStyle][size.value];
          }

        }
        else if (this.seller == "GB"){
          if (this.productType == 'tee'){
              option.text = this.sizeLabels[this.seller]['old'][this.currentStyle][size.value];
          }
          else{
              option.text = this.sizeLabels[this.seller][this.currentStyle][size.value];
          }
        }
      }
      select.appendChild(option);
    }

    this.querySelector('select').addEventListener('change', (event => {
        let selectedSize = event.target.selectedOptions[0];
        this.currentSize = selectedSize.value;
        event.target.options[0].disabled = true;
        this.classList.remove('attention');
        this.updateProductCards(this.currentSize, this.currentStyle, this.productType)
    }));
    this.querySelector('select').value = this.currentSize;
    this.querySelector('select').options[0].disabled = true;
    this.updateProductCards(this.currentSize, this.currentStyle, this.productType)
  }

  // Subscribe to size picker change and update the size & sku on the product card
  async updateProductCards(size, style, productType){
    let url =  `/${productType}/${style}/${size}`
    if(this.preview=="True"){
      url =  `/preview/${productType}/${style}/${size}`
    }
    else{
      url =  `/${productType}/${style}/${size}`
    }
     this.API.get(url)
      .then(data => {
        if(!data.error){
          let productCards = document.querySelectorAll(`product-card[type=${productType}]`)
          const cartItems = document.querySelectorAll(`cart-item`);
          for (const productCard of productCards) {
            let product  = data.products.find(p => p.group == productCard.group);
            if (product) {
              let orginalPrice = productCard.querySelector('.product-pricing .original')
              let discountedPrice = productCard.querySelector('.product-pricing .discounted')
              if (orginalPrice){
                orginalPrice.textContent = product.original_price;
              }
              if (discountedPrice){
                discountedPrice.textContent = product.price;
              }
              productCard.setAttribute("sku", product.sku);
              productCard.shippingDate = product.shipping_date;
              productCard.preorder = product.preorder;
              productCard.setAttribute("size", size);
              productCard.size = size;
              if (product.preorder || (product.available && !product.out_of_stock)) {
                productCard.setAttribute("available", "true");
                productCard.available = 'true';
              }
              else {
                productCard.setAttribute("available", "false");
                productCard.available = 'false';
              }

              productCard.finalSale = product.final_sale;
              for (const cartItem of cartItems) {
                if (cartItem.sku == productCard.sku) {
                  productCard.maxedOut = cartItem.quantity >= 9;
                  break;
                }
              }
            }
            else {
              productCard.setAttribute("sku", '');
              productCard.shippingDate = '';
              productCard.preorder = false;
              productCard.setAttribute("size", size);
              productCard.size = size;
              productCard.setAttribute("available", "false");
              productCard.available = 'false';
              productCard.finalSale = 'false';
            }
            let addBtn = productCard.querySelector('a.button-add');
            if (addBtn && size){
              addBtn.textContent = `Add ${size}`;
            }
          }
        }
        else{
          // handle error here
        }
    }).catch(error => {
        // handle error here
        console.log(error);
    }).then(data => {
    })
  }
  saveSizeData(size){
    let productData = getCookie('product_data');
    let type = this.getAttribute('type');
    let style = this.getAttribute('style');
    if (productData){
      let productDataList= JSON.parse(productData);
      if (productDataList && productDataList.length > 0){
          let product = productDataList.find(function(p){
              if (p.hasOwnProperty(type)){
                 return p;
              }
          });
          if (product){
            if (product[type].hasOwnProperty(style)){
              product[type][style] = size;
              setCookie('product_data', JSON.stringify(productDataList), 10*365);
            } 
        }
      } 
    }
  }
  getSizeFromCookies(){
    let productData = getCookie('product_data');
    let type = this.getAttribute('type');
    let style = this.getAttribute('style');
    let size = null;
    if (productData){
      let productDataList= JSON.parse(productData);
      if (productDataList && productDataList.length > 0){
          let product = productDataList.find(function(p){
              if (p.hasOwnProperty(type)){
                 return p;
              }
          });
          if (product){
            if (product[type].hasOwnProperty(style)){
              size = product[type][style]
            } 
        }
      } 
    }
    return size;
  }
  saveProductData(type, style){
    // push or update type,style to cookies here
    let productData = getCookie('product_data');
    if (productData){
        let productDataList= JSON.parse(productData);
        if (productDataList && productDataList.length > 0){

          let product = productDataList.find(function(p){
              if (p.hasOwnProperty(type)){
                 return p;
              }
          });
          if (product){
                if (!product[type].hasOwnProperty(style)){
                  product[type][style] = null;
                  setCookie('product_data', JSON.stringify(productDataList), 10*365);
                } 
          }
          else{
            productDataList.push({[type]:{[style]:null}})
            setCookie('product_data', JSON.stringify(productDataList), 10*365);
          }
        }
    }
    else{
      productData = [];
      let product = {[type]:{[style]:null}}
      productData.push(product)
      setCookie('product_data', JSON.stringify(productData), 10*365);
    }
  }

}
window.customElements.define('size-picker', SizePicker);
